import { render, staticRenderFns } from "./display-other-choices-summary.vue?vue&type=template&id=75c665f8&"
import script from "./display-other-choices-summary.vue?vue&type=script&lang=js&"
export * from "./display-other-choices-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports